import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";
import api from "../../../utils/api";
import Spinner from "../../../common/Spinner/Spinner";

export default function CentralizedTTNotesModal(props)
{
    const [auditLog,setAuditLog] = useState();
    const [isLoading, setLoading] = useState(false);
    const [ESPServiceNames,setESPServiceNames] = useState([]);
    
      useEffect(() => {
        if(props.isOpen)
        {
            if(props.sEmailId)
            {
                api.getNotesfortooltemplates({email: props.sEmailId,pagination:false,page_size:1000})
                .then((d) => {
                    setAuditLog(d.data);
                    let data=d.data;
                    setLoading(false);
                });
            }            
        }
        
      }, [props.isOpen]);

     const renderAuditTrail = () => {
        return Object.keys(auditLog["results"]).map((key, i) => (

          
         
          <div
                style={{paddingBottom:"5px",marginBottom:"10px",borderBottom:"1px solid lightgray"}}>
               <h5>
               {`${auditLog["results"][i].refService["sResourceDisplayName"]}`}
               {`(${auditLog["results"][i].refService["nResourceInstanceId"]})`}
               
               </h5>
               {`${auditLog["results"][i].refService["sIHHEmail"]}`}

               <span className="conv-float-right">{`${auditLog["results"][i]["dtCreated"]?moment(auditLog["results"][i]["dtCreated"]).format('lll'):""} `}</span>
               
              <div className="audits-body mt-2">
               <br></br>
               <span style={{fontSize:"13px"}}>Notes</span><br></br>
               {`${auditLog["results"][i]["sNotes"]} `}
               <br></br>
               <span style={{fontSize:"13px"}}>Followup Action</span><br></br>
               {`${auditLog["results"][i]["sFollowupAction"]} `}
               <br></br>
               <span style={{fontSize:"13px"}}>Follow up On</span><br></br>
               {`${auditLog["results"][i]["dtFollowupOn"]?moment(auditLog["results"][i]["dtFollowupOn"]).format('ll'):""} `}
              </div>
 
 
           </div>   
         
       ))
      }

      return (
        <Modal
          isOpen={props.isOpen}
          onRequestClose={props.toggleModal}
          ariaHideApp={false}
        >
          <ModalContent>
            <div className="p-2 modal-headers-bar">
              <span>Notes Trail</span>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={props.toggleModal}
              >
                <X style={{ pointerEvents: "none" }} color="white" />
              </button>
            </div>
            <div
              className={`modal-body ${isLoading && "set-opacity"}`}
              style={{ overflowY: "scroll", height: "500px" }}
            >
              {/*{props.selectedSPLedService&&props.selectedSPLedService.custrefSRState!="Cancelled"&&props.selectedSPLedService.custrefSRState!="Delivered"&&
               <div>
                  <button 
                    className="btn r-button primary"
                    style={{float:"right"}}
                    onClick={(e) =>props.onAddNoteClicked(e,props.selectedSPLedService)}>
                      Add Note
                  </button>
                  <div style={{clear:"both"}}></div>
              </div> }*/}
              <div>                
                {auditLog?renderAuditTrail():<div className=" audit-body">No notes taken</div>}
              </div>
              {isLoading && <Spinner className="top" />}
            </div>
            
          </ModalContent>
        </Modal>
      );
}